import React from 'react'

export default function Bar() {
    return (
        <div>
            <svg
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <line
                    x1="0.75"
                    y1="1.25"
                    x2="20.25"
                    y2="1.25"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
                <line
                    x1="0.75"
                    y1="8.25"
                    x2="14.25"
                    y2="8.25"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
                <line
                    x1="0.75"
                    y1="15.25"
                    x2="9.25"
                    y2="15.25"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
            </svg>
        </div>
    )
}
